module.exports = "/_next/static/images/background-25f0b5a71aa9de9ba7dec2aaf1f1414d.svg";